import { ProgressHTMLAttributes } from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { progressIndicatorHeight } from './progressIndicatorHeight';

export type StyledProgressBarProps =
  ProgressHTMLAttributes<HTMLProgressElement> & {
    max: number;
    value: number;
  };
export const StyledProgressBar = styled.progress<StyledProgressBarProps>`
  appearance: none;
  position: relative;
  height: ${progressIndicatorHeight}px;
  width: 100%;
  background-color: ${theme.colors.neutrals.solidGrays[6]};
  color: ${theme.colors.system.systemGreen};
  overflow: hidden;

  &::-webkit-progress-bar {
    background-color: ${theme.colors.neutrals.solidGrays[6]};
  }

  &::-webkit-progress-value {
    background-color: ${theme.colors.system.systemGreen};
    transition: width 200ms ease-in;
  }
  &::-moz-progress-bar {
    height: 0;
    background-color: ${theme.colors.system.systemGreen};
    padding-left: ${progressIndicatorHeight}px;
    padding-bottom: ${({ value, max }) => (value / max) * 100}%;
    transform-origin: 0 0;
    transform: rotate(-90deg) translateX(-${progressIndicatorHeight}px);
    transition: padding-bottom 200ms ease-in;
  }
`;
